<template>
  <div class="">
    <submission-spinner v-if="showSpinner"></submission-spinner>
    <div v-else>
      <div class="" v-if="hasReply">
        <p class="ml-3 pt-1 truncate">
          <a class="cursor-pointer" @click="scrollToMessage">
            <span class="text-xs text-gray-400">
              <svg
                class="w-2 h-4 inline-block underline"
                viewBox="0 0 330.002 330.002"
                fill="currentColor"
              >
                <path
                  d="M 324.001,123.25 173.997,10.75 c -5.334,-4 -12.667,-4 -18,0 L 6.001,123.25 c -6.627,4.971 -7.971,14.373 -3,21 2.947,3.93 7.451,6.001 12.012,6.001 3.131,0 6.29,-0.978 8.988,-3.001 L 164.998,41.5 306.001,147.25 c 6.629,4.972 16.03,3.627 21,-3 4.971,-6.627 3.627,-16.029 -3,-21 z"
                />
              </svg>
            </span>
            <span class="text-xs text-gray-500 font-semibold mx-2">{{
              message.replyingTo.userDisplay
            }}</span>
            <span
              class="text-xs text-gray-500 truncate"
              v-html="message.replyingTo.messageSummary"
            >
            </span>
          </a>
        </p>
      </div>
      <div class="flex flex row">
        <div
          class="py-1"
          :class="{
            'px-4': hasReply,
            'px-3': !hasReply
          }"
          style="word-break: break-word"
        >
          <p
            class="mt-1 max-w-2xl text-xs font-semibold leading-5 text-darkBlue flex items-center"
          >
            {{ message.userDisplay }}
            <span v-if="message.isVectric" class="ml-2">
              <TickIcon class="text-darkBlue h-4 fill-current"></TickIcon>
            </span>
            <a
              v-if="isAdmin"
              @click="remove"
              class="text-aspire underline ml-2 cursor-pointer"
              >[Remove]
            </a>
            <a
              v-if="loggedIn"
              @click="replyTo"
              class="text-darkBlue underline ml-2 cursor-pointer"
              >Reply
            </a>
          </p>

          <vue-markdown
            :source="message_text"
            :anchorAttributes="{ target: '_blank' }"
            class="mt-1 prose text-gray-800"
          ></vue-markdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import { mapGetters } from "vuex";
import SubmissionSpinner from "./SubmissionSpinner";
import ConfirmationModal from "./ConfirmationModal";
import VueMarkdown from "vue-markdown";
import TickIcon from "./schedule/TickIcon.vue";

export default {
  name: "Message",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    TickIcon,
    SubmissionSpinner,
    VueMarkdown
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  methods: {
    remove() {
      this.$emit("remove-message", this.message);
    },
    replyTo() {
      this.$emit("reply-to", this.message);
    },
    scrollToMessage() {
      this.$emit("scroll-to-message", this.message.replyingTo);
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "deletedMessageID", "loggedIn"]),
    hasReply() {
      return (
        this.message.replyingTo !== null &&
        this.message.replyingTo !== undefined
      );
    },
    showSpinner() {
      if (this.deletedMessageID === this.message.id) {
        return true;
      }
      return false;
    },
    message_text() {
      let msg = this.message.body.replace("<", "&lt;").replace(">", "&gt;");
      return msg.replace(/(^|\s)(@[^\s]+)/gi, "$1<u>$2</u>");
    }
  }
};
</script>

<style scoped></style>
